'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FolderPropTypes } from 'DesignData/propTypes/finder';
import { setActiveProjectFolderId } from 'DesignData/actions/finder/Projects';
import { getActiveProjectFolderId, makeGetFolderPath } from 'DesignData/selectors/finder';
import Bar from 'DesignFinderUI/components/commandbar/Bar';
import RootFolderNav from 'DesignFinderUI/components/nav/RootFolderNav';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBackButton from 'UIComponents/nav/UIBackButton';
import UILink from 'UIComponents/link/UILink';

function makeMapStateToProps() {
  const getFolderPath = makeGetFolderPath();
  return (state, props) => {
    const activeProjectFolderId = getActiveProjectFolderId(state);
    let path = null;

    if (activeProjectFolderId) {
      props = Object.assign({}, props, {
        assetId: activeProjectFolderId,
        folderId: activeProjectFolderId
      });
      path = (getFolderPath(state, props) || []).join('/');
    }

    return {
      activeProjectFolderId,
      path
    };
  };
}

const mapDispatchToProps = {
  setActiveProjectFolderId
};

class ProjectCommandBar extends Component {
  constructor(...args) {
    super(...args);

    this.clearActiveProjectFolderId = () => {
      this.props.setActiveProjectFolderId(null);
    };
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.activeProjectFolderId !== this.props.activeProjectFolderId) {
      return true;
    }

    if (nextProps.activeProjectFolderId && nextProps.path !== this.props.path) {
      return true;
    }

    return false;
  }

  renderBackButton() {
    return /*#__PURE__*/_jsx(UIBackButton, {
      size: "xs",
      "data-test-id": "back-to-all-files-button",
      children: /*#__PURE__*/_jsx(UILink, {
        onClick: this.clearActiveProjectFolderId,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "DesignFinderUI.breadcrumbs.backToAll.text"
        })
      })
    });
  }

  render() {
    if (!this.props.activeProjectFolderId) {
      return null;
    }

    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Bar, {
        left: this.renderBackButton()
      }), /*#__PURE__*/_jsx(RootFolderNav, Object.assign({}, this.props, {
        type: "command-bar",
        rootFolderId: this.props.activeProjectFolderId,
        onUpdateCanDrop: this.props.onUpdateCanDrop,
        closeContextMenu: this.props.closeContextMenu,
        openContextMenu: this.props.openContextMenu
      }))]
    });
  }

}

ProjectCommandBar.propTypes = {
  activeProjectFolderId: FolderPropTypes.folderId,
  path: PropTypes.string,
  setActiveProjectFolderId: PropTypes.func.isRequired,
  onUpdateCanDrop: PropTypes.func.isRequired,
  closeContextMenu: PropTypes.func.isRequired,
  openContextMenu: PropTypes.func.isRequired
};
export default connect(makeMapStateToProps, mapDispatchToProps)(ProjectCommandBar);